import React, { useState, useEffect } from 'react';
import { compose } from 'recompose';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import {
  RegisterPlanMySelfButton,
  RegisterPlanOnBehalfButton,
} from '../../../../../../styledComponents/styles/Action.buttons.styled';

import { AccentButtonMediumNunito } from '../../../../../../styledComponents/styles/Buttons.styled';
import StyledIcon from '../../../../../../styledComponents/styles/Icon.styled';
import s from './registerTravelPlanModal.scss';
import BaseModalHeader from '../../../../../../components/baseModal/BaseModalHeader';
import locationIcon from '../../../../../../shared/images/location.png';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import { getAuthorizedTravelers } from '../../../../../../actions/proxyManagmentActions';
import userId from '../../../../../../shared/helpers/userId';

export const enhance = compose(withStyles(s));

const RegisterTravelPlanModal = ({ show, onClose }) => {
  const [planType, setPlanType] = useState('');
  const { is_proxy_user } = useSelector(state => state.profile);
  const disaptch = useDispatch();
  const { authorizedTravelers, authorizedTravelersLoading } = useSelector(state => state.proxy);



  useEffect(() => {
    if (is_proxy_user) {
      disaptch(getAuthorizedTravelers(userId));
    }
  }, [is_proxy_user]);




  return (
    <Modal show={show} onHide={onClose} centered size="lg">
      <BaseModalHeader heading="Register Travel Plan" onClose={onClose} />

      {authorizedTravelersLoading ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '300px' }}>Loading...</div> : <div className={s.flexContainer}>

        <main className={s.main}>
          <div className={s.title}>Who are you creating this plan for?</div>
          <div className={s.buttonDiv}>
            <div className={s.buttonContainer}>
              <RegisterPlanMySelfButton
                onClick={() => {
                  setPlanType('myself');
                }}
              />
            </div>

            <div className={s.buttonContainer}>
              <RegisterPlanOnBehalfButton
                disabled={authorizedTravelers.length === 0}
                onClick={() => {
                  setPlanType('onbehalf');
                }}
              />
            </div>
          </div>
          <main className={s.nextContainer}>
            <AccentButtonMediumNunito
              disabled={!planType}
              onClick={() => {
                if (planType === 'myself') {
                  window.location.href = '/traveler/create-solo-plan';
                }

                if (planType === 'onbehalf') {
                  window.location.href = '/traveler/create-solo-plan?type=onbehalf';
                }
              }}
            >
              Next
              <StyledIcon type="ChevronForward" color="#fff" />
            </AccentButtonMediumNunito>
          </main>
        </main>
        <div
          className={s.informationSection}
        >
          <img src={locationIcon} alt={'Register Travel'} />
        </div>
      </div>}


    </Modal>
  );
};

export default enhance(RegisterTravelPlanModal);
